import { IInstance } from '../../../Instances'
import { FunctionalityTemplate } from '../../../Functionality'
import { FunctionalityValidator } from '../../../FunctionalityValidator'
import { FunctionalityPreset } from '../../../FunctionalityPreset'

export enum LicenseState {
	ACTIVE = 'active',
	DEBTOR = 'debtor',
	CONTRACT_TERMINATION = 'contractTermination',
	MQ_REGULATION_ISSUES = 'mqRegulationIssues',
	BUSINESS_FINANCIAL_ISSUES = 'businessFinancialIssues',
	BUGS_AND_INCIDENTS = 'bugsAndIncidents',
	MISSED_FEATURE = 'missedFeature',
	CANCELLED_FOR_TECH_REASONS = 'cancelledForTechnicalReasons',
	ON_HOLD = 'onHold',
	OTHERS = 'others',
	EXPIRED = 'expired',
}

export enum LicenseType {
	REAL = 'real',
	TRIAL = 'trial',
	_ = '',
}

export interface FunctionalityWithDisplayName {
	functionalityTemplateId: string
	displayName: string,
	value: string | Array<FunctionalityValidator>
}

export interface OneFunctionalityInSet {
	functionalityId: string,
	value: string | Array<FunctionalityValidator>
}

export type FunctionalitiesSet = Record<
	OneFunctionalityInSet['functionalityId'],
	OneFunctionalityInSet['value']
>

export interface ILicense {
	licenseId: string
	creationDate: string
	expirationDate?: Date
	type: LicenseType
	state: LicenseState
	maxLiveInstances: number
	isMaxLiveInstancesExceeded: boolean
	updateReason: string // updateReason in license itself is only on frontend side
	allowedVersions: string[] //deprecated
	numberOfInstances: string
	clientBrief: {
		clientId: string
		companyNames: string[]
	}
	productBrief: {
		name: string
		productId: string
		functionalitiesTemplates: Array<FunctionalityTemplate>
		functionalitiesPresets: Array<FunctionalityPreset>
	}
	functionalitiesPresetId?: string
	functionalitiesSet?: FunctionalitiesSet
	functionalitiesWithDisplayName?: Array<FunctionalityWithDisplayName>
	instances?: Array<IInstance>
}

export interface LicenseSchema {
	cachedLicense: ILicense
	licenseEditable: ILicense
	isLoading: boolean
	error?: string
}
